import {
    maximumAcceptedLengthBigCode,
    minimumAcceptedLengthBigCode,
} from '../validation/schemas/identifierDeclarationSchemas';

export function padStartBigCode(identifierRegistrationBig: string | null | undefined) {
    if (!identifierRegistrationBig || identifierRegistrationBig.length < minimumAcceptedLengthBigCode) {
        return identifierRegistrationBig;
    }

    return identifierRegistrationBig.padStart(maximumAcceptedLengthBigCode, '0');
}
